/* GLASSIQUE | Cart features. Does not change Shopify checkout or discounts. */
(() => {
  'use strict';
  if (window.__glassiqueCartInitialized) return;
  window.__glassiqueCartInitialized = true;

  const protectionVariantId = 61251442770254;
  const timerKey = 'glassique:cart-reminder-10m:v1';
  const durationMs = 10 * 60 * 1000;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;
  let hadTimer = false;

  function cartEndpoint(action) {
    return root.replace(/\/?$/, '/') + 'cart/' + action + '.js';
  }

  async function request(url, options) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload.description || payload.message || 'Non è stato possibile aggiornare il carrello.');
    }
    return payload;
  }

  function getCart() { return request(cartEndpoint('')); }

  function getDeadline() {
    let stored = null;
    try { stored = Number(sessionStorage.getItem(timerKey)); } catch (_e) {}
    if (!Number.isFinite(stored) || !stored || stored - Date.now() > durationMs) {
      stored = Date.now() + durationMs;
      try { sessionStorage.setItem(timerKey, String(stored)); } catch (_e) {}
    }
    return stored;
  }

  function renderCountdowns() {
    const blocks = document.querySelectorAll('[data-gq-countdown]');
    if (!blocks.length) {
      if (hadTimer) {
        try { sessionStorage.removeItem(timerKey); } catch (_e) {}
        hadTimer = false;
      }
      return;
    }
    hadTimer = true;
    const left = Math.max(0, Math.ceil((getDeadline() - Date.now()) / 1000));
    const value = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    blocks.forEach((block) => {
      const output = block.querySelector('[data-gq-countdown-value]');
      if (output) output.textContent = value;
      block.classList.toggle('is-expired', !left);
      const copy = block.querySelector('[data-gq-countdown-label]');
      if (copy) copy.textContent = left ? 'COMPLETA IL TUO ORDINE IN' : 'PUOI ANCORA COMPLETARE L’ORDINE';
    });
  }

  function setProtectionState(checked) {
    document.querySelectorAll('[data-gq-protection-toggle]').forEach((el) => {
      el.checked = checked;
    });
  }
  function setLoading(loading) {
    document.querySelectorAll('[data-gq-protection]').forEach((el) => {
      el.classList.toggle('is-loading', loading);
      const cb = el.querySelector('[data-gq-protection-toggle]');
      if (cb) cb.disabled = loading;
    });
  }
  function showError(message) {
    document.querySelectorAll('[data-gq-protection-error]').forEach((el) => {
      el.hidden = !message;
      el.textContent = message || '';
    });
  }

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-gq-protection-toggle]');
    if (!input || busy) return;
    busy = true;
    const desired = input.checked;
    showError('');
    setLoading(true);
    try {
      const cart = await request(root.replace(/\/?$/, '/') + 'cart.js');
      const current = cart.items.find((item) => Number(item.variant_id) === protectionVariantId);
      if (desired && !current) {
        await request(cartEndpoint('add'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({items: [{id: protectionVariantId, quantity: 1}]})
        });
      } else if (!desired && current) {
        await request(cartEndpoint('change'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({id: current.key, quantity: 0})
        });
      }
      const updated = await request(root.replace(/\/?$/, '/') + 'cart.js');
      const nowSelected = updated.items.some((item) => Number(item.variant_id) === protectionVariantId);
      setProtectionState(nowSelected);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      if (/\/(cart)\/?$/.test(window.location.pathname)) {
        window.location.reload();
      } else {
        setTimeout(() => {
          const toggles = [...document.querySelectorAll('[data-gq-protection-toggle]')];
          const drawer = document.querySelector('cart-drawer');
          const drawerHasItem = !!(drawer && drawer.querySelector('.gq-protection-item'));
          const drawerOutOfSync = drawer && drawerHasItem !== nowSelected;
          if (!toggles.length || drawerOutOfSync || toggles.some((el) => el.checked !== nowSelected)) window.location.reload();
        }, 1800);
      }
    } catch (error) {
      setProtectionState(!desired);
      showError(error.message || 'Riprova tra qualche istante.');
    } finally {
      setLoading(false);
      busy = false;
    }
  });

  renderCountdowns();
  window.setInterval(renderCountdowns, 1000);
})();
